var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataRefresh = function SvgDataRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F9194",
    d: "M12.322 6.799c.401.04.694.398.654.799a5.99 5.99 0 0 1-5.963 5.38c-1.703 0-3.373-.603-4.533-1.75v.497a.73.73 0 0 1-1.46 0v-2.31a1.05 1.05 0 0 1 .307-.74l.076-.068a1.05 1.05 0 0 1 .662-.236h2.316a.73.73 0 1 1 0 1.458H3.184c.832 1.06 2.248 1.691 3.829 1.691a4.53 4.53 0 0 0 4.511-4.067.73.73 0 0 1 .798-.654M6.987 1.02c1.703 0 3.373.604 4.534 1.75v-.496a.73.73 0 0 1 1.458 0v2.31l-.005.103a1.04 1.04 0 0 1-1.04.94H9.62a.73.73 0 1 1 0-1.457h1.197C9.984 3.11 8.568 2.48 6.987 2.479a4.53 4.53 0 0 0-4.511 4.068.73.73 0 0 1-1.452-.144 5.99 5.99 0 0 1 5.963-5.382"
  })));
};
export default SvgDataRefresh;